(function () {
  if (window.__dmPhoneRevealBound) return;
  window.__dmPhoneRevealBound = true;

  function rev(s) {
    return String(s || '').split('').reverse().join('');
  }

  function attr(el, name) {
    return el ? el.getAttribute(name) : null;
  }

  function classPart(el, prefix) {
    if (!el || !el.className) return null;
    var parts = String(el.className).split(/\s+/);
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(prefix) === 0) return parts[i].slice(prefix.length);
    }
    return null;
  }

  function partsFrom(btn, item) {
    var a = attr(btn, 'data-pa') || attr(item, 'data-pa') || classPart(item, 'dm-pa-');
    var b = attr(btn, 'data-pb') || attr(item, 'data-pb') || classPart(item, 'dm-pb-');
    var c = attr(btn, 'data-pc') || attr(item, 'data-pc') || classPart(item, 'dm-pc-');
    var cc = attr(btn, 'data-cc') || attr(item, 'data-cc') || '1';
    if ((!a || !b || !c) && btn) {
      var href = attr(btn, 'href') || '';
      var m = href.match(/#r-(\d+)-(\d+)-(\d+)/);
      if (m) {
        a = a || m[1];
        b = b || m[2];
        c = c || m[3];
      }
    }
    return { a: a, b: b, c: c, cc: cc };
  }

  function reveal(btn) {
    if (!btn || btn.getAttribute('aria-expanded') === 'true') return;
    var item = btn.closest('.dm-phone-item');
    var p = partsFrom(btn, item);
    var a = rev(p.a);
    var b = rev(p.b);
    var c = rev(p.c);
    var cc = p.cc || '1';
    if (!a || !b || !c) return;
    var display = a + '-' + b + '-' + c;
    var href = 'tel:+' + cc + a + b + c;
    var target = item && item.querySelector('.dm-phone-revealed');
    if (!target) return;
    if (target.querySelector('a[href^="tel:"]')) {
      btn.setAttribute('aria-expanded', 'true');
      if (item) item.classList.add('is-revealed');
      return;
    }
    var link = document.createElement('a');
    link.href = href;
    link.textContent = display;
    target.appendChild(link);
    target.hidden = false;
    target.style.display = '';
    target.removeAttribute('aria-hidden');
    btn.setAttribute('aria-expanded', 'true');
    if (item) item.classList.add('is-revealed');
    link.focus();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.dm-phone-reveal');
    if (!btn) return;
    e.preventDefault();
    reveal(btn);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest && e.target.closest('.dm-phone-reveal');
    if (!btn) return;
    e.preventDefault();
    reveal(btn);
  });
})();
